import { GameManager } from "../../GameManager";
import { Background } from "../Background";
import { GameVars } from "../../GameVars";
import { LowerMenu } from "../LowerMenu";
import { GameConstants } from "../../GameConstants";
import { PlayerInfoContainer } from "../PlayerInfoContainer";
import { AudioButtonContainer } from "../AudioButtonContainer";
import { ShopContainer } from "./ShopContainer";
import { Game } from "../../Game";

export class ShopScene extends Phaser.Scene {

    public static currentInstance: ShopScene;

    private playerAvatar: PlayerInfoContainer;
    private shopContainer: ShopContainer;

    constructor() {

        super("ShopScene");
    }

    public create(): void {

        ShopScene.currentInstance = this;

        GameManager.setCurrentScene(this);   

        const background = new Background(this, 1);
        this.add.existing(background);

        this.playerAvatar = new PlayerInfoContainer(this);
        this.add.existing(this.playerAvatar);

        const audioButton = new AudioButtonContainer(this);
        audioButton.x = GameConstants.GAME_WIDTH - 60;
        audioButton.y = 60 * GameVars.scaleY;
        audioButton.scaleY = GameVars.scaleY;
        this.add.existing(audioButton);

        this.shopContainer = new ShopContainer(this);
        this.add.existing(this.shopContainer);

        const lowerMenu = new LowerMenu(this);
        this.add.existing(lowerMenu);

        if (!this.sys.game.device.os.desktop) {
            this.input.on("pointerup", function(): void {
                Game.currentInstance.launchIntoFullscreen(document.documentElement);
            }, this);
        }
    }

    public onItemPurchased(): void {

        this.shopContainer.updateItems();
        this.playerAvatar.updateBalance();
    }
}
